import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
// import 'react-h5-audio-player/lib/styles.css';
import UseAPI from 'lib/api/UseAPI';
import api_config from 'lib/api/common';
import AudioPlayerH5 from 'lib/player/AudioPlayerH5';


const AudioEmbed = () => {
  const[audioURL, setAudioURL] = useState(null);
  const [ttsLoading, setTTSLoading] = useState(false);
  const [title, setTitle] = useState(null);
  const [brandCSS, setBrandCSS] = useState(null);

  const { uuid } = useParams();

  const fetchShareDetail = (ttsUUID) => {
    if(ttsLoading) {
      return false;
    }
    setTTSLoading(true);
    let url = api_config.BASE_BACKEND_ENDPOINT + 'api/audio/share/'+ ttsUUID.replace("audio-", "") +'/';
    let abortController = new AbortController();
    const signal = abortController.signal;
    UseAPI(signal, url, 'GET', {})
      .then(function (data) {
          if(data.uuid) {
            setTitle(data.title);
            setAudioURL(data.audio_url);
            setBrandCSS(data.brand);
          }
          setTTSLoading(false);
      })
      .catch(function (err) {
          setTTSLoading(false);
      });
  }

  useEffect(() => {
        //console.log(uuid);
        fetchShareDetail(uuid);
    return () => {};
  }, [uuid]);
  
  useEffect(() => {
    if(title) {
      document.title = title;
      document.documentElement.style.overflow = 'hidden';
    }
    else {
      document.title = "'";
    }
    return () => {
      document.title = "";
      document.documentElement.style.overflow = 'hidden';
    };
  }, [title, brandCSS]);

  return (
    <>
      <div id="idShareContainer" style={{display: 'flex', flexDirection: 'column', paddingLeft: '10px', paddingRight: '10px', height: '100vh', alignItems: 'center', 
            justifyContent: 'center', background: 'transparent'}}>
          {
            audioURL && 
            <AudioPlayerH5 url={audioURL} audioTitle={title} playerCSS={brandCSS} showFooter={false}/>
          }
      </div>
    </>
  );
};

export default AudioEmbed;
